import React from 'react';
import { Handshake, ExternalLink } from 'lucide-react';
import { PARTNERS } from '../mock';

export default function Partners() {
  return (
    <section id="partnerzy" className="bg-white py-24 md:py-28 border-t border-slate-200/70">
      <div className="max-w-[1200px] mx-auto px-6 lg:px-8">
        <div className="text-[12px] font-semibold tracking-[0.25em] text-[#0f1a2b]/60 mb-4">WSPÓŁPRACA</div>
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 items-start">
          <div className="lg:col-span-5">
            <h2 className="font-heading font-extrabold text-[36px] md:text-[46px] leading-[1.08] tracking-tight text-[#0f1a2b]">
              Zaufali mi między innymi
            </h2>
            <p className="mt-6 text-[15px] leading-relaxed text-[#0f1a2b]/75 max-w-lg">
              Współpracuję z firmami przemysłowymi, wykonawcami i inwestorami z różnych branż. Każdy projekt traktuję indywidualnie, dopasowując zakres prac do specyfiki inwestycji.
            </p>
          </div>

          <div className="lg:col-span-7 grid grid-cols-1 sm:grid-cols-2 gap-4">
            {PARTNERS.map((p) => (
              <a
                key={p.name}
                href={p.url}
                target="_blank"
                rel="noopener noreferrer"
                className="group flex items-center gap-4 rounded-2xl bg-[#f5f5f7] hover:bg-white border border-slate-200 hover:border-[#f5c518] p-5 hover-lift transition-colors"
              >
                <div className="h-11 w-11 rounded-lg bg-[#132a44] flex items-center justify-center flex-shrink-0">
                  <Handshake className="h-5 w-5 text-[#f5c518]" />
                </div>
                <div className="flex-1 min-w-0">
                  <div className="font-heading font-semibold text-[15px] tracking-tight text-[#0f1a2b] leading-snug">
                    {p.name}
                  </div>
                </div>
                <ExternalLink className="h-4 w-4 text-[#0f1a2b]/40 group-hover:text-[#f5c518] flex-shrink-0 transition-colors" />
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
